var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.accountLocked)?_c('b-field',{staticClass:"password-wrapper",attrs:{"label":"password 🤫 magic spell"}},[_c('b-input',{attrs:{"value":_vm.value,"type":"password","password-reveal":""},on:{"input":_vm.handlePassword}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }